import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "#444545",
  "stroke-linecap": "round",
  "stroke-width": "3",
  viewBox: "0 0 240 240"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M237.412 1.519H1.45v235.962h235.962z" }, null, -1),
    _createElementVNode("path", {
      "stroke-linecap": "butt",
      d: "M153.929 111.22c24.01-15.868 52.712-25.113 83.621-25.113V1.519H153.1c0 30.91-9.245 59.612-25.114 83.622 7.314 9.797 16.145 18.49 25.943 26.08zM139.3 1.52h-39.74c0 26.08 7.313 50.504 19.87 71.34 12.695-20.836 19.87-45.122 19.87-71.34zm98.11 137.851V99.63c-26.079 0-50.503 7.313-71.34 19.87 20.837 12.695 45.261 19.87 71.34 19.87zM85.073 127.918c-24.01 15.868-52.712 25.114-83.622 25.114v84.449H85.9c0-30.91 9.245-59.612 25.113-83.622-7.313-9.659-16.144-18.49-25.94-25.942zM1.45 85.968c30.91 0 59.612 9.246 83.622 25.114 9.797-7.45 18.49-16.282 25.941-25.94C95.283 61.267 85.9 32.428 85.9 1.518H1.45M142.476 119.5a149.8 149.8 0 0 1-22.907-22.906A149.8 149.8 0 0 1 96.663 119.5a149.8 149.8 0 0 1 22.906 22.906c6.761-8.417 14.35-16.007 22.907-22.906zm94.936 33.532c-30.91 0-59.612-9.246-83.622-25.115-9.797 7.452-18.49 16.283-25.941 25.942a151.05 151.05 0 0 1 25.114 83.622h84.449zM99.56 237.48h39.74c0-26.08-7.313-50.504-19.87-71.34-12.557 20.836-19.87 45.26-19.87 71.34zM1.45 139.37c26.08 0 50.504-7.314 71.34-19.87C51.954 106.942 27.53 99.63 1.45 99.63"
    }, null, -1)
  ])))
}
export default { render: render }